module.exports = __webpack_public_path__ + "static/media/dark-theme-idiling-duration.ca7e12b7.svg";